import { recipeHasConditions } from '@builder-legacy/item/conditions/utilities';

/**
 * Returns a conditions group given an ID
 *
 * @param {Object} options                   The options
 * @param {String} options.conditionsGroupId The ID of the conditions group
 * @return {ConditionsGroup}                 The conditions group
 */
const getConditionsGroupById = ( { conditionsGroupId } ) => {
	// Default response
	let conditionsGroup = null;

	// Check if the recipe has conditions
	if ( recipeHasConditions() ) {
		// Check if the conditions group exists
		if ( _uo.utility.isDefined( UncannyAutomator.recipe.conditions[ conditionsGroupId ] ) ) {
			// Found it. Save it
			conditionsGroup = UncannyAutomator.recipe.conditions[ conditionsGroupId ];
		}
	}

	return conditionsGroup;
};

export default getConditionsGroupById;
